var map = {
	"./sano/DataSource": [
		78987,
		8987
	],
	"./shirahama/DataSource": [
		3420,
		3420
	],
	"./taiji/DataSource": [
		91145,
		1145
	],
	"./toyonaka/DataSource": [
		97256,
		7256
	],
	"./water-supply-portal-trial/DataSource": [
		99737,
		9737
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67871;
module.exports = webpackAsyncContext;